import { ArrowRight, Lock, ExternalLink } from "lucide-react";
import { IMAGES, PARTNER_URL } from "@/lib/site";

const CARDS = [
  {
    img: IMAGES.pillar1,
    alt: "Misuratore elettrico con forma d'onda blu dell'energia",
    tag: "FORNITURA",
    tagColor: "#7dd3fc",
    glow: "radial-gradient(circle at 70% 30%, #38bdf844 0%, transparent 60%)",
    title: "Luce & Gas",
    text: "Tariffe ottimizzate e zero costi nascosti per abitazioni e sedi produttive.",
    cta: "Richiedi analisi",
    testid: "card-luce-gas",
  },
  {
    img: IMAGES.pillar2,
    alt: "Pannelli fotovoltaici moderni al tramonto con riflesso arancione",
    tag: "FOTOVOLTAICO",
    tagColor: "#ff6a00",
    glow: "radial-gradient(circle at 30% 30%, #ff6a0055 0%, transparent 65%)",
    title: "Impianti Solari",
    text: "Dimensionamento personalizzato per l'indipendenza energetica del tuo immobile.",
    cta: "Richiedi preventivo",
    testid: "card-fotovoltaico",
  },
  {
    img: IMAGES.pillar3,
    alt: "Consulente che analizza grafici di dati energetici",
    tag: "ASSISTENZA",
    tagColor: "#c084fc",
    glow: "radial-gradient(circle at 50% 50%, #c084fc44 0%, transparent 60%)",
    title: "Audit Dedicato",
    text: "Un consulente fisico di riferimento per ogni esigenza di gestione e reclamo.",
    cta: "Parla con noi",
    testid: "card-consulenza",
  },
];

export function PillarsSection() {
  return (
    <section className="py-24 px-6 max-w-6xl mx-auto">
      <div className="text-center max-w-xl mx-auto mb-16">
        <span className="font-mono text-xs text-[#ff6a00] uppercase tracking-widest block mb-2">I NOSTRI AMBITI</span>
        <h2 className="font-display text-3xl sm:text-4xl uppercase text-white tracking-wide">
          SOLUZIONI CHIARE E MISURABILI
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {CARDS.map((c, i) => (
          <div
            key={c.testid}
            data-testid={c.testid}
            className="rounded-2xl border border-white/10 bg-white/[0.02] p-6 flex flex-col justify-between sn-card-stagger"
            style={{ animationDelay: `${0.6 + i * 0.08}s` }}
          >
            <div className="relative h-44 rounded-xl overflow-hidden mb-6">
              <img src={c.img} alt={c.alt} loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
              <div className="absolute inset-0" style={{ background: c.glow }}></div>
              <div className="absolute inset-0 bg-gradient-to-t from-[#0d1230]/70 to-transparent"></div>
              <div
                className="absolute bottom-3 left-3 bg-black/60 backdrop-blur px-2.5 py-1 rounded text-[10px] font-mono"
                style={{ color: c.tagColor }}
              >
                {c.tag}
              </div>
            </div>
            <div>
              <h3 className="text-lg font-bold text-white mb-2">{c.title}</h3>
              <p className="text-xs text-slate-400 leading-relaxed mb-4">{c.text}</p>
            </div>
            <a href="#contattaci" className="text-xs text-[#ff6a00] font-mono uppercase tracking-wider hover:underline inline-flex items-center gap-1">
              {c.cta} <ArrowRight className="w-3 h-3" />
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}

export function CoverageBand() {
  return (
    <section className="relative py-20 px-6 border-y border-white/10 overflow-hidden">
      <img
        src={IMAGES.fullbleed}
        alt=""
        aria-hidden="true"
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover opacity-40"
      />
      <div className="absolute inset-0" style={{ background: "radial-gradient(80% 50% at 50% 50%, #7c3aed40 0%, transparent 100%), linear-gradient(180deg, #0d1230cc, #221a4dcc, #0d1230cc)" }}></div>
      <div className="max-w-4xl mx-auto text-center relative z-10">
        <span className="font-mono text-xs uppercase tracking-widest text-[#ff6a00] block mb-3">COPERTURA NAZIONALE</span>
        <h2 className="font-display text-4xl sm:text-5xl uppercase text-white mb-4">
          VICINI ALLE PERSONE, RAPIDI NELLE RISPOSTE
        </h2>
        <p className="text-sm text-slate-300 max-w-xl mx-auto mb-8 font-light">
          Operiamo in tutta Italia attraverso professionisti radicati nelle singole province.
        </p>
        <div className="inline-flex flex-wrap justify-center items-center gap-6 font-mono text-xs text-slate-400">
          <span>✓ ASSISTENZA DIRETTA</span>
          <span>✓ ZERO CALL CENTER ANONIMI</span>
          <span>✓ TEMPI RAPIDI</span>
        </div>
      </div>
    </section>
  );
}

export function PartnerSection() {
  return (
    <section id="partner" className="py-20 px-6 max-w-4xl mx-auto">
      <div className="rounded-3xl border border-white/15 bg-gradient-to-r from-[#16265c] via-[#241d55] to-[#0d1230] p-8 sm:p-12 relative overflow-hidden text-center">
        <div className="absolute -top-12 -right-12 w-48 h-48 bg-[#f43f5e]/15 rounded-full blur-2xl"></div>

        <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-white/5 border border-white/20 flex items-center justify-center">
          <Lock className="w-8 h-8 text-[#f43f5e]" />
        </div>

        <span className="font-mono text-xs text-[#f43f5e] uppercase tracking-widest block mb-2">FUNZIONE 03</span>
        <h2 className="font-display text-3xl sm:text-4xl uppercase text-white mb-4">AREA PARTNER</h2>
        <p className="text-sm text-slate-300 max-w-lg mx-auto mb-8 font-light">
          Accesso riservato alla piattaforma gestionale per la gestione pratiche e monitoraggio contratti.
        </p>

        {PARTNER_URL ? (
          <a
            href={PARTNER_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="partner-access-button"
            className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 border border-white/20 text-white font-mono text-xs uppercase tracking-widest px-8 py-3.5 rounded-xl transition-colors"
          >
            <span>Accedi al Gestionale Partner</span>
            <ExternalLink className="w-4 h-4" />
          </a>
        ) : (
          <div data-testid="partner-access-pending">
            <span className="inline-flex items-center gap-2 bg-white/5 border border-white/10 text-slate-400 font-mono text-xs uppercase tracking-widest px-8 py-3.5 rounded-xl cursor-not-allowed">
              <Lock className="w-4 h-4" />
              <span>Accedi al Gestionale Partner</span>
            </span>
            <p className="text-[11px] font-mono text-[#ff6a00]/80 mt-3">Accesso in configurazione — disponibile a breve</p>
          </div>
        )}
        <p className="text-[11px] font-mono text-slate-500 mt-4">Piattaforma protetta riservata alla rete commerciale attiva</p>
      </div>
    </section>
  );
}
